import { render, staticRenderFns } from "./SmallImageUpload.vue?vue&type=template&id=3f608cd2&"
import script from "./SmallImageUpload.vue?vue&type=script&lang=js&"
export * from "./SmallImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports